import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = ({ onAction }) => {
  const quickActions = [
    {
      id: 'new-order',
      label: 'New Order',
      icon: 'Plus',
      variant: 'default',
      description: 'Create new client order'
    },
    {
      id: 'add-inventory',
      label: 'Add Inventory',
      icon: 'Package',
      variant: 'outline',
      description: 'Add stock items'
    },
    {
      id: 'generate-report',
      label: 'Generate Report',
      icon: 'FileText',
      variant: 'outline',
      description: 'Create business reports'
    },
    {
      id: 'production-schedule',
      label: 'Schedule Production',
      icon: 'Calendar',
      variant: 'outline',
      description: 'Plan production workflow'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 h-full">
      <h3 className="text-lg font-semibold text-foreground mb-6">Quick Actions</h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 min-h-[370px]">
        {quickActions.map((action) => (
          <Button
            key={action.id}
            variant={action.variant}
            size="lg"
            onClick={() => onAction(action.id)}
            iconName={action.icon}
            iconPosition="left"
            iconSize={20}
            className="justify-start h-auto p-4 flex-col items-start space-y-2"
          >
            <div className="flex items-center space-x-3 w-full">
              <span className="font-medium">{action.label}</span>
            </div>
            <span className="text-xs text-muted-foreground text-left">
              {action.description}
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;